<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Benutzer</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-6 col-lg-12">
                    <stats-card
                        title="Benutzer"
                        type="gradient-red"
                        :sub-title="total"
                        icon="fad fa-users"
                        class="mb-4 mb-xl-0">
                        <template v-slot:footer>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-6 col-lg-12">
                    <stats-card
                        :title="(currentUser.realmRoles.indexOf('userAdmin') !== -1) ? 'Admins': 'Kundenadmins'"
                        type="gradient-orange"
                        :sub-title="number"
                        icon="fad fa-users"
                        class="mb-4 mb-xl-0">
                        <template v-slot:footer>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <UsersTable @changed="getUserData"></UsersTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsersTable from '@/views/Tables/UsersTable';
import StatsCard from '@/components/Cards/StatsCard';

export default {
    name: "Users",
    components: {
        StatsCard,
        UsersTable,
    },
    methods: {
        getUserData(data) {
            let number = 0;
            this.users = data;
            this.total = data.length.toString();
            data.map(item => {
                if (item.attributes.clientAdmin == 1) number++;
            });
            this.number = number.toString();
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    data() {
        return {
            value: 1,
            users: [],
            total: '0',
            number: '0'
        };
    },
}
</script>

<style scoped lang="scss">
.card-profile-stats {
    padding: 0.4em 0.8em 0 0;
    margin-bottom: 0.4em;
}

.card-profile-stats > div {
    text-align: center;
    padding: 0.1em 1.2em 0 1.2em;
    margin-bottom: 0;
}

@media (max-width: 1700px) {
    .card-profile-stats > div {
        text-align: center;
        padding: 0.1em 0.8em 0 0;
        margin-bottom: 0;
    }
}

.sectionIcon {
    top: 1.5em;
    position: absolute;
    right: 1em;
}
</style>
